import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const EditAI = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.7902 7.12003C14.5602 9.88003 16.7202 12.04 19.4902 12.82M15.0902 5.82003L6.00016 14.91C5.65016 15.26 5.31016 15.94 5.24016 16.43L4.74016 19.9C4.56016 21.16 5.44016 22.04 6.70016 21.86L10.1702 21.36C10.6502 21.29 11.3402 20.94 11.6902 20.6L20.7902 11.5C22.3602 9.93003 23.1002 8.11003 20.7902 5.80003C18.4802 3.49003 16.6602 4.23003 15.0902 5.80003V5.82003Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.18 1.79999C6.25 1.62999 6.5 1.62999 6.57 1.79999L7.72 4.52999C7.74 4.57999 7.78 4.61999 7.83 4.63999L10.56 5.78999C10.73 5.85999 10.73 6.10999 10.56 6.17999L7.83 7.32999C7.78 7.34999 7.74 7.38999 7.72 7.43999L6.57 10.17C6.5 10.34 6.25 10.34 6.18 10.17L5.03 7.43999C5.01 7.38999 4.97 7.34999 4.92 7.32999L2.19 6.17999C2.02 6.10999 2.02 5.85999 2.19 5.78999L4.92 4.63999C4.97 4.61999 5.01 4.57999 5.03 4.52999L6.18 1.79999Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
